import { render, staticRenderFns } from "./DirectoryBreadcrumbs.vue?vue&type=template&id=326a69bc"
import script from "./DirectoryBreadcrumbs.vue?vue&type=script&lang=ts"
export * from "./DirectoryBreadcrumbs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports